import axios, { AxiosError } from 'axios'
import { prepareConfigInterceptor } from './interceptors/requestInterceptors'
import { onResponseSuccess, onResponseError } from './interceptors/responseInterceptors'
import { API_BASE_URL, API_REQUEST_TIMEOUT_MS } from '@/constants'

export type HttpError = Error | AxiosError | null

const httpClient = axios.create({
  timeout: API_REQUEST_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  baseURL: API_BASE_URL,
})

httpClient.interceptors.request.use(prepareConfigInterceptor)
httpClient.interceptors.response.use(onResponseSuccess, onResponseError)

export default httpClient
